import { render, staticRenderFns } from "./CreditAuthorization.vue?vue&type=template&id=31a83537&"
import script from "./CreditAuthorization.vue?vue&type=script&lang=js&"
export * from "./CreditAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a83537')) {
      api.createRecord('31a83537', component.options)
    } else {
      api.reload('31a83537', component.options)
    }
    module.hot.accept("./CreditAuthorization.vue?vue&type=template&id=31a83537&", function () {
      api.rerender('31a83537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/contracts/CreditAuthorization.vue"
export default component.exports